module.exports = __webpack_public_path__ + "static/media/assembly_S1.d1e8cbed.png";